import type { Dictionary } from "../dictionary";

const ka: Dictionary = {
  meta: {
    siteName: "Tetri Software",
    defaultTitle: "Tetri Copilot LLC — ინტელექტუალური ბიზნეს პროგრამული უზრუნველყოფა",
    defaultDescription:
      "Tetri Copilot LLC ქმნის Tetri-ის ინტელექტუალურ ბიზნეს პროდუქტების ოჯახს — Tetri Copilot-სა და Tetri Engage-ს — და სთავაზობს შერჩეულ პროგრამული უზრუნველყოფის, AI და ვებ განვითარების სერვისებს.",
  },

  nav: {
    home: "მთავარი",
    products: "პროდუქტები",
    services: "სერვისები",
    company: "კომპანია",
    contact: "კონტაქტი",
    productsMenu: {
      copilot: "Tetri Copilot",
      copilotHint: "ფინანსები და ოპერაციები — გამარტივებულად",
      engage: "Tetri Engage",
      engageHint: "შესაძლებლობები პრიორიტეტით",
      viewAll: "ყველა პროდუქტის ნახვა",
    },
    cta: "პროდუქტების ნახვა",
    openMenu: "მენიუს გახსნა",
    closeMenu: "მენიუს დახურვა",
    languageLabel: "ენა",
    skipToContent: "გადასვლა კონტენტზე",
  },

  footer: {
    tagline:
      "Tetri Copilot LLC ქმნის ინტელექტუალურ პროგრამულ უზრუნველყოფას, რომელიც ბიზნესს ეხმარება იმუშაოს, ჩართოს კლიენტები და გაიზარდოს ნაკლები სირთულით.",
    productsHeading: "პროდუქტები",
    servicesHeading: "სერვისები",
    companyHeading: "კომპანია",
    legalHeading: "სამართლებრივი",
    company: {
      about: "ჩვენ შესახებ",
      services: "სერვისები",
      contact: "კონტაქტი",
      partnerships: "პარტნიორობა",
    },
    legal: {
      privacy: "კონფიდენციალურობის პოლიტიკა",
      terms: "მომსახურების პირობები",
      cookies: "Cookie-ების პოლიტიკა",
    },
    rights: "ყველა უფლება დაცულია.",
    registeredNote: "Tetri Copilot LLC რეგისტრირებულია საქართველოში.",
  },

  productPanel: {
    copilotTitle: "სამუშაო სივრცის მიმოხილვა",
    engageTitle: "პროცესის მიმოხილვა",
    copilotRows: [
      { label: "ინვოისი · კლიენტი A", status: "გაგზავნილი" },
      { label: "ინვოისი · კლიენტი B", status: "გადახდილი" },
      { label: "ხარჯი · მივლინება", status: "შეტანილი" },
    ],
    engageRows: [
      { label: "შესაძლებლობა · სიგნალი A", status: "ახალი" },
      { label: "შესაძლებლობა · სიგნალი B", status: "კვალიფიციური" },
      { label: "შემდგომი კონტაქტი · სიგნალი C", status: "დღეს" },
    ],
    copilotScreenshotAlt:
      "Tetri Copilot-ის დაფა შემოსავლის, გადაუხდელი ინვოისების, წმინდა ფულადი სახსრებისა და ფულადი ნაკადის გრაფიკით",
    engageScreenshotAlt:
      "Tetri Engage-ის შესაძლებლობების სია AI-ქულებით და ავტომატურად შექმნილი შემდგომი მოქმედებით",
  },

  common: {
    buttons: {
      exploreProducts: "პროდუქტების ნახვა",
      contactUs: "დაგვიკავშირდით",
      talkToUs: "მოგვწერეთ",
      learnMore: "შეიტყვეთ მეტი",
      visitProduct: "პროდუქტზე გადასვლა",
      discussProject: "პროექტის განხილვა",
      sendMessage: "შეტყობინების გაგზავნა",
      viewAllProducts: "ყველა პროდუქტი",
      backHome: "მთავარ გვერდზე დაბრუნება",
      viewServices: "სერვისების ნახვა",
      readMore: "სრულად წაკითხვა",
    },
    badges: {
      live: "აქტიური",
      beta: "ბეტა",
      comingSoon: "მალე",
    },
    labels: {
      capabilities: "შესაძლებლობები",
      builtFor: "შექმნილია",
      relatedProducts: "დაკავშირებული პროდუქტები",
    },
  },

  seo: {
    home: {
      title: "Tetri Software — ინტელექტუალური ბიზნეს პროგრამები მცირე და საშუალო ბიზნესისთვის",
      description: "AI-ით გაძლიერებული ბიზნეს პროგრამული უზრუნველყოფა მზარდი კომპანიებისთვის საქართველოში, არაბთა გაერთიანებულ საემიროებში, საუდის არაბეთში, აშშ-სა და მსოფლიოში: Tetri Copilot და Tetri Engage.",
    },
    products: {
      title: "ბიზნეს პროგრამები: Tetri Copilot და Tetri Engage | Tetri Software",
      description: "შეადარეთ Tetri Copilot ინვოისებისთვის, ხარჯებისა და შესაბამისობისთვის და Tetri Engage პოტენციური კლიენტების მოძიებისა და შემდგომი კონტაქტებისთვის.",
    },
    copilot: {
      title: "Tetri Copilot: ინვოისებისა და ბუღალტრული ადმინისტრირების პროგრამა | Tetri Software",
      description: "ინვოისები, ხარჯები, ბიზნეს ჩანაწერები, შესაბამისობის კონტროლი და ანგარიშგება ერთ AI-ით გაძლიერებულ სამუშაო სივრცეში მცირე ბიზნესისთვის საქართველოში და მის ფარგლებს გარეთ.",
    },
    engage: {
      title: "Tetri Engage: კლიენტების მოძიება და შემდგომი კონტაქტი AI-ით | Tetri Software",
      description: "იპოვეთ პერსპექტიული შესაძლებლობები, დაალაგეთ პოტენციური კლიენტები AI შეფასებით და მართეთ ყველა შემდგომი კონტაქტი. გაყიდვების გუნდებისთვის.",
    },
    services: {
      title: "პროგრამული უზრუნველყოფის, AI-ისა და ვებ დეველოპმენტი | Tetri Software",
      description: "SaaS დეველოპმენტი, AI ავტომატიზაცია, ვებ აპლიკაციები და ვებსაიტები იმ გუნდისგან, რომელიც ქმნის Tetri Copilot-სა და Tetri Engage-ს. კლიენტებისთვის საქართველოში, UAE-ში, საუდის არაბეთსა და აშშ-ში.",
    },
    about: {
      title: "Tetri Copilot LLC-ის შესახებ | Tetri Software",
      description: "Tetri Copilot LLC საქართველოში რეგისტრირებული პროგრამული უზრუნველყოფის კომპანიაა, რომელიც Tetri-ის პროდუქტებს ქმნის ბიზნესებისთვის საქართველოში, UAE-ში, საუდის არაბეთში, აშშ-სა და მსოფლიოში.",
    },
    contact: {
      title: "დაუკავშირდით Tetri-ს | Tetri Software",
      description: "გაქვთ კითხვა Tetri Copilot-ის, Tetri Engage-ის, პარტნიორობის ან პროექტის შესახებ? დაუკავშირდით Tetri-ის გუნდს ელფოსტით, ტელეფონით ან ფორმით.",
    },
  },

  home: {
    hero: {
      heading: "პროგრამული უზრუნველყოფა, რომელიც ბიზნესს ამარტივებს.",
      subheading:
        "Tetri ქმნის ფოკუსირებულ ბიზნეს პროდუქტებს. Tetri Copilot მართავს ფინანსებსა და ადმინისტრირებას, Tetri Engage პოულობს შესაძლებლობებს და მათზე შემდგომ კონტაქტს უზრუნველყოფს, ხოლო მათ უკან მდგომი გუნდი შერჩეულ კლიენტთა პროექტებსაც იღებს.",
      ctaPrimary: "პროდუქტების ნახვა",
      ctaSecondary: "მოგვწერეთ",
    },
    stage: {
      copilot: {
        description: "ინვოისები, ხარჯები, ჩანაწერები, შესაბამისობის კონტროლი და ანგარიშგება ერთ სამუშაო სივრცეში.",
        cta: "Tetri Copilot-ის ნახვა",
      },
      engage: {
        description: "პოტენციური კლიენტების აღმოჩენა, შესაძლებლობების შეფასება და შემდგომი კონტაქტები, რომლებიც არ იკარგება.",
        cta: "Tetri Engage-ის ნახვა",
      },
    },
    work: {
      heading: "ბიზნესის მართვა უფრო მეტ სამუშაოს ქმნის, ვიდრე ნებისმიერ გუნდს შეუძლია გაუმკლავდეს.",
      body: "Tetri-ის თითოეული პროდუქტი ამ სამუშაოს ერთ ნაწილს იღებს და ფოკუსირებულ, ინტელექტუალურ პროცესად აქცევს, რათა თქვენმა გუნდმა ნაკლები დრო დახარჯოს სისტემების მართვაზე.",
      listLabel: "სად მიდის სამუშაო",
      items: [
        { problem: "ჩანაწერები, ინვოისები და შესაბამისობის ამოცანები გაფანტულია სხვადასხვა ხელსაწყოში", product: "copilot" },
        { problem: "ანგარიშები, რომლებიც ყოველთვიურად ხელით მზადდება", product: "copilot" },
        { problem: "პერსპექტიული შესაძლებლობები იკარგება ინფორმაციის ნაკადში", product: "engage" },
        { problem: "შემდგომი კონტაქტები შეუმჩნევლად იკარგება", product: "engage" },
      ],
    },
    copilot: {
      heading: "ბიზნესის ადმინისტრირება, რომელიც ხელს არ გიშლით.",
      body: "ერთი თანამედროვე სამუშაო სივრცე ბიზნესის ადმინისტრაციული მხარისთვის, სადაც რუტინულ ნაწილს AI ასრულებს.",
      capabilities: ["ინვოისები", "ხარჯები", "ბიზნეს ჩანაწერები", "შესაბამისობის კონტროლი", "ანგარიშგება", "AI დახმარება"],
      cta: "Tetri Copilot-ის ნახვა",
    },
    engage: {
      heading: "სიგნალიდან შემდგომ კონტაქტამდე — ნაკლები ხელით შესრულებული სამუშაოთი.",
      body: "Tetri Engage ეხმარება მზარდ გუნდებს იპოვონ პერსპექტიული შესაძლებლობები, გადაწყვიტონ, რომელია ყველაზე მნიშვნელოვანი, და ყველა შემდგომი კონტაქტი კონტროლის ქვეშ ჰქონდეთ.",
      steps: [
        { title: "ჩნდება სიგნალი", description: "Engage ამჩნევს აქტივობას, რომელიც ყურადღებას იმსახურებს." },
        { title: "შესაძლებლობა ფასდება", description: "AI ალაგებს მათ, რომ გუნდმა ჯერ ყველაზე ძლიერ შესაძლებლობებზე იმუშაოს." },
        { title: "იქმნება შემდგომი კონტაქტი", description: "შემდეგი ნაბიჯი სწორი ადამიანის სიაში ხვდება." },
      ],
      cta: "Tetri Engage-ის ნახვა",
    },
    ai: {
      heading: "AI-მ სამუშაო უნდა შეამციროს და არა ახალი სამართავი სისტემა შექმნას.",
      body: "ორივე პროდუქტს ერთი მიდგომა აქვს: AI კონკრეტულ ამოცანას ასრულებს იმ პროცესის შიგნით, რომელსაც უკვე იყენებთ.",
      points: [
        { title: "დახმარება", description: "გთავაზობთ შემდეგ ნაბიჯებს თქვენს ჩანაწერებზე და ამზადებს რუტინულ ნაწილს, ასე რომ ამოცანები ნახევრად შესრულებული იწყება." },
        { title: "კლასიფიკაცია", description: "ახარისხებს და ტეგავს ჩანაწერებსა და შესაძლებლობებს, რომ ხელით დახარისხების გარეშე სწორ ადგილას მოხვდნენ." },
        { title: "პრიორიტეტიზაცია", description: "გამოკვეთს, რას სჭირდება ყურადღება პირველ რიგში — ვადიანი შესაბამისობის ამოცანიდან ყველაზე ძლიერ შესაძლებლობამდე." },
      ],
    },
    services: {
      heading: "იგივე პროდუქტული აზროვნება — თქვენს პროექტში.",
      body: "გუნდი, რომელიც ქმნის Tetri Copilot-სა და Tetri Engage-ს, კლიენტთა მცირე რაოდენობის პროექტებს იღებს — იგივე საინჟინრო სტანდარტებით.",
      cta: "პროექტის განხილვა",
      items: [
        { title: "ინდივიდუალური პროგრამული უზრუნველყოფა და SaaS", description: "პორტალები, შიდა სისტემები, დაფები და SaaS პროდუქტები, ნულიდან შექმნილი." },
        { title: "AI და ავტომატიზაცია", description: "AI ფუნქციები თქვენს არსებულ პროგრამულ უზრუნველყოფაში და განმეორებადი პროცესების ავტომატიზაცია." },
        { title: "ვებსაიტები და დიზაინ სისტემები", description: "ინდივიდუალურად დაპროგრამებული მარკეტინგული საიტები და მრავალჯერადი დიზაინ სისტემები, სწრაფი და SEO-სთვის მზად." },
        { title: "ინტეგრაციები და კონსულტაცია", description: "API და გადახდების ინტეგრაციები, ღრუბლოვანი არქიტექტურა და ტექნიკური მოდერნიზაცია." },
      ],
      processLabel: "როგორ მიმდინარეობს პროექტი",
      process: [
        { title: "კვლევა", description: "პრობლემისა და შედეგის განსაზღვრა." },
        { title: "დიზაინი", description: "პროდუქტის ფორმირება კოდამდე." },
        { title: "შექმნა", description: "მიწოდება შემოწმებულ ეტაპებად." },
        { title: "მხარდაჭერა", description: "მართვა, გაზომვა და გაუმჯობესება." },
      ],
    },
    company: {
      heading: "პროდუქტის კომპანია, შექმნილი მთელი მსოფლიოს ბიზნესების მოსამსახურებლად.",
      facts: [
        { value: "2", label: "ბაზარზე არსებული პროდუქტი" },
        { value: "4", label: "ენა: ინგლისური, არაბული, ქართული, რუსული" },
        { value: "გლობალური", label: "პრიორიტეტული ბაზრები: საქართველო, არაბთა გაერთიანებული საემიროები, საუდის არაბეთი და აშშ" },
        { value: "საქართველო", label: "Tetri Copilot LLC, რეგისტრირებული საქართველოში" },
      ],
      trust: [
        { title: "დაცული ღრუბლოვანი ტექნოლოგია.", description: "აგებულია თანამედროვე, მხარდაჭერად ღრუბლოვან ინფრასტრუქტურაზე." },
        { title: "კონფიდენციალურობაზე ორიენტირებული დიზაინი.", description: "თითოეული პროდუქტი აგროვებს მხოლოდ იმას, რაც ნამდვილად სჭირდება." },
        { title: "გამჭვირვალე გამოწერები.", description: "მკაფიო ფასები, დამალული პირობების გარეშე." },
      ],
    },
    finalCta: {
      heading: "იპოვეთ Tetri-ის პროდუქტი, რომელიც თქვენი ზრდის შემდეგ ეტაპს შეესაბამება.",
      body: "გაეცანით Tetri Copilot-სა და Tetri Engage-ს, ან მოგვწერეთ, რა სჭირდება თქვენს ბიზნესს შემდეგ.",
      ctaPrimary: "პროდუქტების ნახვა",
      ctaSecondary: "დაუკავშირდით Tetri-ს",
    },
  },

  about: {
    hero: {
      eyebrow: "კომპანია",
      heading: "კომპანია Tetri-ის პროდუქტების ოჯახის მიღმა.",
      subheading:
        "Tetri Copilot LLC აპროექტებს, ქმნის და მართავს ინტელექტუალურ ბიზნეს პროგრამულ უზრუნველყოფას — და სთავაზობს შერჩეულ განვითარების სერვისებს მცირერიცხოვან კლიენტებს.",
    },
    statement: {
      heading: "რას ვაკეთებთ",
      body: [
        "Tetri Copilot LLC პროდუქტის კომპანიაა. ვქმნით, გვეკუთვნის და ვმართავთ Tetri-ის ბიზნეს აპლიკაციების ოჯახს, დაწყებული Tetri Copilot-ითა და Tetri Engage-ით.",
        "ასევე ვთანამშრომლობთ შერჩეულ კლიენტებთან საკუთარი პროგრამული უზრუნველყოფის, AI-სა და ვებ განვითარების პროექტებზე — იმავე პროდუქტული დისციპლინით, რომელსაც საკუთარ პროგრამულ უზრუნველყოფაზე ვიყენებთ.",
      ],
    },
    builds: {
      heading: "რას ქმნის Tetri",
      body: "Tetri-ის თითოეული პროდუქტი ბიზნეს ოპერაციების კონკრეტულ სფეროზეა ფოკუსირებული, საერთო მიდგომით სიმარტივის, ინტელექტუალური ავტომატიზაციისა და თანამედროვე დიზაინის მიმართ.",
      points: [
        { title: "Tetri Copilot", description: "AI-ით გაძლიერებული ბიზნეს ადმინისტრირება, ფინანსური ოპერაციები და შესაბამისობა მცირე და საშუალო ბიზნესებისთვის." },
        { title: "Tetri Engage", description: "AI-ით გაძლიერებული შესაძლებლობების აღმოჩენა, პრიორიტეტიზაცია და შემდგომი კონტაქტები მზარდი გუნდებისთვის." },
      ],
    },
    vision: {
      heading: "რატომ არსებობს Tetri",
      body: "მზარდი ბიზნესები საოპერაციო სამუშაოს უფრო სწრაფად აგროვებენ, ვიდრე მისთვის კადრების აყვანა შეუძლიათ — გაფანტული ჩანაწერები, დაკარგული შემდგომი კონტაქტები და ავტომატიზაცია, რომელიც სირთულეს ამატებს მის შემცირების ნაცვლად. Tetri არსებობს იმისთვის, რომ ეს ფრაგმენტული სამუშაო გარდაქმნას ფოკუსირებულ, ინტელექტუალურ პროგრამულ უზრუნველყოფად, რომლის მართვაც მცირე გუნდსაც შეუძლია.",
    },
    principles: {
      eyebrow: "როგორ ვმუშაობთ",
      heading: "პრინციპები Tetri-ის ყველა პროდუქტის მიღმა.",
      items: [
        { title: "პრაქტიკული ინტელექტი", description: "AI-მ სამუშაო უნდა შეამციროს და არა ახალი სამართავი სისტემები შექმნას." },
        { title: "სიმარტივე", description: "რთული საოპერაციო ამოცანები გასაგებ პროგრამულ უზრუნველყოფად უნდა იქცეს." },
        { title: "სასარგებლო ავტომატიზაცია", description: "ავტომატიზაციამ უნდა მოაშოროს განმეორებადი სამუშაო იქ, სადაც რეალურ ღირებულებას ქმნის." },
        { title: "ხარისხი", description: "დიზაინი, ინჟინერია, წარმადობა და საიმედოობა მნიშვნელოვანია ყოველ განახლებაში." },
        { title: "ნდობა", description: "ბიზნეს პროგრამული უზრუნველყოფა საიმედო, დაცული და გამჭვირვალე უნდა იყოს." },
        { title: "მუდმივი გაუმჯობესება", description: "პროდუქტები ვითარდება რეალური მომხმარებლის საჭიროებების, და არა ვარაუდების საფუძველზე." },
      ],
    },
    international: {
      heading: "სად ვმუშაობთ",
      body: "Tetri შექმნილია როგორც საერთაშორისო პროდუქტების ოჯახი, ფოკუსით შემდეგ ბაზრებზე.",
      markets: [
        { code: "GE", name: "საქართველო", note: "საბაზისო ბაზარი და საოპერაციო ბაზა" },
        { code: "AE", name: "არაბთა გაერთიანებული საემიროები", note: "პრიორიტეტული ზრდის ბაზარი" },
        { code: "SA", name: "საუდის არაბეთი", note: "პრიორიტეტული ზრდის ბაზარი" },
        { code: "US", name: "ამერიკის შეერთებული შტატები", note: "პრიორიტეტული ზრდის ბაზარი" },
        { code: "GCC", name: "სპარსეთის ყურის ქვეყნები", note: "გაფართოებადი რეგიონული ფოკუსი" },
        { code: "Global", name: "მთელი მსოფლიო", note: "ხელმისაწვდომია ნებისმიერი ქვეყნის ბიზნესისთვის" },
      ],
    },
    technology: {
      heading: "როგორ ვქმნით პროდუქტებს",
      body: "Tetri-ის ყოველი პროდუქტი აგებულია თანამედროვე, მხარდაჭერად ტექნოლოგიებზე — ისე, რომ საიმედო დარჩეს პროდუქტების ოჯახის ზრდასთან ერთად.",
      points: [
        "თანამედროვე ვებ აპლიკაციები",
        "ღრუბლოვანი, მასშტაბირებადი არქიტექტურა",
        "API-ზე დაფუძნებული ინტეგრაციები",
        "AI გამოიყენება იქ, სადაც საზომ ღირებულებას ქმნის",
        "უსაფრთხოება და კონფიდენციალურობა გათვალისწინებულია დასაწყისიდანვე",
      ],
    },
    legal: {
      heading: "კორპორატიული ინფორმაცია",
      body: "Tetri Copilot LLC არის იურიდიული პირი Tetri-ის პროდუქტების ოჯახისა და ამ ვებგვერდზე აღწერილი სერვისების მიღმა.",
      entityLabel: "იურიდიული პირი",
      entityValue: "Tetri Copilot LLC",
      jurisdictionLabel: "რეგისტრირებულია",
      jurisdictionValue: "საქართველოში",
      contactLabel: "საქმიანი მიმართვები",
    },
    cta: {
      heading: "გსურთ მეტი შეიტყოთ Tetri-ის შესახებ?",
      body: "გაეცანით, რას ვქმნით, ან პირდაპირ დაგვიკავშირდით.",
      ctaPrimary: "პროდუქტების ნახვა",
      ctaSecondary: "დაგვიკავშირდით",
    },
  },

  products: {
    compare: {
      heading: "Tetri-ის რომელი პროდუქტი გჭირდებათ?",
      focusLabel: "მთავარი ამოცანა",
      audienceLabel: "ვისთვისაა",
      outcomeLabel: "რა იცვლება",
      capabilitiesLabel: "შესაძლებლობები",
    },
    hero: {
      eyebrow: "პროდუქტები",
      heading: "Tetri-ის პროდუქტების ოჯახი.",
      subheading:
        "ორი ფოკუსირებული პროდუქტი, შექმნილი და მართული Tetri Copilot LLC-ის მიერ, საერთო მიდგომით სიმარტივის, ინტელექტუალური ავტომატიზაციისა და თანამედროვე დიზაინის მიმართ.",
    },
    list: [
      {
        name: "Tetri Copilot",
        tagline: "ფინანსები და ოპერაციები — გამარტივებულად",
        outcome: "ნაკლები დრო ქაღალდზე, მეტი — ბიზნესზე.",
        description:
          "AI-ით გაძლიერებული ბიზნეს ადმინისტრირება მცირე და საშუალო ბიზნესებისთვის — ინვოისები, ხარჯები, ჩანაწერები, შესაბამისობის კონტროლი და ანგარიშგება ერთ თანამედროვე სამუშაო სივრცეში.",
        capabilities: ["ინვოისები", "ხარჯები", "ბიზნეს ჩანაწერები", "შესაბამისობის კონტროლი", "ანგარიშგება", "AI დახმარება"],
        audience: "მცირე ბიზნესის მფლობელები, ფინანსური და საოპერაციო გუნდები",
        ctaLabel: "Tetri Copilot-ის ნახვა",
      },
      {
        name: "Tetri Engage",
        tagline: "შესაძლებლობები პრიორიტეტით",
        outcome: "ნაკლები დაკარგული შესაძლებლობა სავსე ინბოქსის გამო.",
        description:
          "AI-ით გაძლიერებული შესაძლებლობების აღმოჩენა და ჩართულობა მზარდი გუნდებისთვის — შესაძლებლობების აღმოჩენა, პრიორიტეტების დალაგება და შემდგომი კონტაქტების ორგანიზება.",
        capabilities: ["შესაძლებლობების აღმოჩენა", "სიგნალები", "პრიორიტეტიზაცია", "შემდგომი კონტაქტები", "ჩართულობის პროცესები", "AI დახმარება"],
        audience: "გაყიდვებისა და კლიენტებთან მომუშავე გუნდები",
        ctaLabel: "Tetri Engage-ის ნახვა",
      },
    ],
    philosophy: {
      heading: "ერთი ოჯახი, ერთი ფილოსოფია",
      body: "Tetri-ის თითოეული პროდუქტი ბიზნეს ოპერაციების კონკრეტულ სფეროზეა ფოკუსირებული, საერთო მიდგომით სიმარტივის, ინტელექტუალური ავტომატიზაციისა და თანამედროვე დიზაინის მიმართ — ამიტომ გამოცდილება ერთგვაროვანია, რომელი პროდუქტიც არ უნდა გამოიყენოთ.",
    },
    future: {
      heading: "შექმნილია ზრდისთვის",
      body: "Tetri-ის პროდუქტების არქიტექტურა შექმნილია იმისთვის, რომ მომავალი პროდუქტების დამატება შესაძლებელი იყოს მათი გამოცხადებისთანავე, ოჯახის ერთობლივი მუშაობის ხელახლა დაპროექტების გარეშე.",
    },
    cta: {
      heading: "გსურთ Tetri-ის პროდუქტი უფრო ახლოს გაიცნოთ?",
      body: "ეწვიეთ სპეციალურ პროდუქტის ვებგვერდს სრული დეტალებისთვის, ან დაგვიკავშირდით კითხვების შემთხვევაში.",
      ctaLabel: "დაუკავშირდით Tetri-ს",
    },
  },

  copilotPage: {
    eyebrow: "Tetri Copilot",
    heading: "ბიზნესის ადმინისტრირება, რომელიც ხელს არ გიშლით.",
    intro:
      "Tetri Copilot ეხმარება მცირე და მზარდ ბიზნესებს მოაწესრიგონ ინვოისები, ხარჯები, ჩანაწერები, შესაბამისობის აქტივობები, ანგარიშგება და ყოველდღიური ადმინისტრირება ერთ თანამედროვე სამუშაო სივრცეში.",
    problemHeading: "პრობლემა",
    problemBody:
      "ბიზნესის ადმინისტრირება ხშირად ცხრილებში, ელფოსტასა და დაუკავშირებელ ხელსაწყოებში იფანტება — ინვოისები უკონტროლოდ რჩება, ხარჯები დაგვიანებით ფიქსირდება, ხოლო შესაბამისობის ვადები ბოლო წუთს აღმოჩნდება. Tetri Copilot ამ სამუშაოს ერთ ადგილას აერთიანებს.",
    capabilitiesHeading: "რას აკეთებს Tetri Copilot",
    capabilities: [
      { title: "ინვოისები", description: "შექმენით, გაგზავნეთ და თვალი მიადევნეთ ინვოისებს სამუშაო სივრცის დატოვების გარეშე." },
      { title: "ხარჯები", description: "დააფიქსირეთ და მოაწესრიგეთ ბიზნეს ხარჯები მათი წარმოქმნისთანავე." },
      { title: "ბიზნეს ჩანაწერები", description: "შეინახეთ ძირითადი ბიზნეს ინფორმაცია მოწესრიგებული და ადვილად საპოვნელი." },
      { title: "შესაბამისობის კონტროლი", description: "თვალი ადევნეთ განმეორებად შესაბამისობის აქტივობებსა და ვადებს." },
      { title: "ანგარიშგება", description: "გადააქციეთ ყოველდღიური ჩანაწერები ნათელ, გამოსადეგ ანგარიშებად." },
      { title: "AI დახმარება", description: "AI ეხმარება ძიებაში, კლასიფიკაციასა და დრაფტინგში — ამცირებს ხელით შესრულებულ ადმინისტრაციულ სამუშაოს." },
    ],
    outcomesHeading: "რა იცვლება",
    outcomes: [
      "ბიზნეს ჩანაწერები ერთ მოწესრიგებულ სამუშაო სივრცეშია გაფანტული ხელსაწყოების ნაცვლად",
      "ინვოისირება და ხარჯების აღრიცხვა წუთებს, და არა საათებს მოითხოვს",
      "შესაბამისობის ვადები ჩანს ვადამდე, სანამ გადაუდებელი გახდება",
      "ანგარიშგება ასახავს რეალურ, განახლებულ ინფორმაციას",
    ],
    aiHeading: "AI-ის როლი",
    aiBody:
      "Tetri Copilot AI-ს იყენებს ყოველდღიურ ადმინისტრირებაში დასახმარებლად — ჩანაწერების პოვნაში, ხარჯების კლასიფიკაციასა და ჩვეულებრივი დოკუმენტების დრაფტინგში — რომ გუნდმა ნაკლები დრო დახარჯოს ხელით მონაცემთა შეყვანაზე.",
    audienceHeading: "ვისთვისაა განკუთვნილი",
    audiences: ["მცირე ბიზნესის მფლობელები და მენეჯერები", "ფინანსური და საოპერაციო გუნდები", "მზარდი ბიზნესები, რომლებიც ცხრილებს ანაცვლებენ"],
    scopeNote:
      "Tetri Copilot აწესრიგებს ბიზნეს ჩანაწერებს, ინვოისირებასა და შესაბამისობის კონტროლს. იგი არ ინახავს და არ ამუშავებს კლიენტების ფინანსებს, არ მოქმედებს როგორც ბანკი ან საგადამხდელო დაწესებულება და არ სთავაზობს დაკრედიტებას ან საინვესტიციო კონსულტაციას.",
    ctaHeading: "გაეცანით Tetri Copilot-ს სრულად",
    ctaBody: "ეს გვერდი კორპორატიული მიმოხილვაა. ეწვიეთ Tetri Copilot-ის ოფიციალურ ვებგვერდს სრული პროდუქტის გასაცნობად.",
    ctaLabel: "Tetri Copilot-ზე გადასვლა",
    relatedHeading: "დაკავშირებული პროდუქტები",
  },

  engagePage: {
    flowHeading: "როგორ მუშაობს Tetri Engage",
    eyebrow: "Tetri Engage",
    heading: "სიგნალიდან შემდგომ კონტაქტამდე — ნაკლები ხელით შესრულებული სამუშაოთი.",
    intro:
      "Tetri Engage ეხმარება მზარდ გუნდებს აღმოაჩინონ პერსპექტიული შესაძლებლობები, დაალაგონ პრიორიტეტები, მოაწესრიგონ შემდგომი კონტაქტები და შეამცირონ განმეორებადი სამუშაო კლიენტებთან ურთიერთობაში.",
    problemHeading: "პრობლემა",
    problemBody:
      "პერსპექტიული შესაძლებლობები იკარგება სავსე ინბოქსის ნაკადში, ხოლო ხელით შემდგომი კონტაქტი კარგად არ მასშტაბირდება გუნდის ზრდასთან ერთად. Tetri Engage გაფანტულ სიგნალებს გარდაქმნის მოწესრიგებულ, პრიორიტეტიზებულ პროცესად.",
    capabilitiesHeading: "რას აკეთებს Tetri Engage",
    capabilities: [
      { title: "შესაძლებლობების აღმოჩენა", description: "აღმოაჩინეთ პერსპექტიული შესაძლებლობები, სანამ დაიკარგება." },
      { title: "სიგნალები", description: "გარდაქმენით შესაბამისი აქტივობა კონკრეტულ, მოქმედებად სიგნალებად." },
      { title: "შესაძლებლობების პრიორიტეტიზაცია", description: "ნახეთ, რა საჭიროებს ყურადღებას ყველაზე ჯერ." },
      { title: "შემდგომი კონტაქტები", description: "შეინახეთ ყოველი შემდგომი კონტაქტი მოწესრიგებულად და გრაფიკის მიხედვით." },
      { title: "ჩართულობის პროცესები", description: "დაასტრუქტურეთ კომუნიკაცია ხელით რუტინის გარეშე." },
      { title: "AI დახმარება", description: "AI ეხმარება კვალიფიკაციაში, პრიორიტეტიზაციასა და კომუნიკაციის დრაფტინგში." },
    ],
    outcomesHeading: "რა იცვლება",
    outcomes: [
      "შესაძლებლობები აღმოჩენილი და მოწესრიგებულია დაკარგვის ნაცვლად",
      "გუნდმა იცის, რაზე იმუშაოს ჯერ",
      "შემდგომი კონტაქტები ხდება გრაფიკის მიხედვით და არა მეხსიერების იმედად",
      "ნაკლები განმეორებადი ხელით შესრულებული სამუშაო",
    ],
    aiHeading: "AI-ის როლი",
    aiBody:
      "Tetri Engage AI-ს იყენებს შესაძლებლობების კვალიფიკაციაში, პრიორიტეტების დალაგებასა და შემდგომი კომუნიკაციის დრაფტინგში დასახმარებლად — გუნდი კი ყოველთვის აკონტროლებს, რა იგზავნება.",
    audienceHeading: "ვისთვისაა განკუთვნილი",
    audiences: ["გაყიდვებისა და კლიენტებთან მომუშავე გუნდები", "მზარდი გუნდები სპეციალური საოპერაციო ფუნქციის გარეშე", "გუნდები, რომლებიც დღეს ხელით შემდგომ კონტაქტს ეყრდნობიან"],
    scopeNote:
      "Tetri Engage მხარს უჭერს შესაძლებლობების აღმოჩენასა და მოწესრიგებულ შემდგომ კონტაქტს. იგი არ იძლევა გარანტიას გაყიდვების შედეგებზე ან ლიდების ხარისხზე, არ ახორციელებს შეუზღუდავ მონაცემთა შეგროვებას და არ აგზავნის სრულად ავტონომიურ კომუნიკაციას გუნდის კონტროლის გარეშე.",
    ctaHeading: "გაეცანით Tetri Engage-ს სრულად",
    ctaBody: "ეს გვერდი კორპორატიული მიმოხილვაა. ეწვიეთ Tetri Engage-ის ოფიციალურ ვებგვერდს სრული პროდუქტის გასაცნობად.",
    ctaLabel: "Tetri Engage-ზე გადასვლა",
    relatedHeading: "დაკავშირებული პროდუქტები",
  },

  services: {
    hero: {
      eyebrow: "სერვისები",
      heading: "იგივე პროდუქტული აზროვნება — თქვენს პროექტში.",
      subheading:
        "Tetri Copilot LLC ქმნის Tetri Copilot-სა და Tetri Engage-ს, როგორც საკუთარ პროდუქტებს — და იმავე საინჟინრო დისციპლინას იყენებს შერჩეულ კლიენტთა პროექტებზე მუშაობისას.",
    },
    categories: [
      {
        slug: "saas-development",
        title: "SaaS პროდუქტების განვითარება",
        summary: "SaaS აპლიკაციების სრული ციკლის დაპროექტება და განვითარება — პირველი გამოშვებიდან შემდგომ იტერაციამდე.",
        outcomes: ["საწარმოებლად მზა SaaS პროდუქტი", "არქიტექტურა, აგებული რეალურ დატვირთვაზე ზრდისთვის", "მხარდაჭერადი კოდის ბაზა, რომლის განვითარებაც თქვენს გუნდს შეუძლია"],
      },
      {
        slug: "ai-automation",
        title: "AI-ის დანერგვა და ავტომატიზაცია",
        summary: "პრაქტიკული AI ფუნქციები და პროცესების ავტომატიზაცია ახალ ან უკვე არსებულ პროგრამულ უზრუნველყოფაში.",
        outcomes: ["AI დახმარება, ჩაშენებული რეალურ სამუშაო პროცესებში", "ავტომატიზაცია ნამდვილად განმეორებადი ამოცანებისთვის", "ინტელექტუალური ძიება, კლასიფიკაცია და პრიორიტეტიზაცია"],
      },
      {
        slug: "web-development",
        title: "ვებ აპლიკაციების განვითარება",
        summary: "პორტალები, საინფორმაციო პანელები და შიდა ხელსაწყოები, აგებული თქვენი ბიზნესის რეალურ პროცესებზე.",
        outcomes: ["ხელსაწყო, შექმნილი თქვენს პროცესზე და არა შაბლონზე", "სუფთა ინტეგრაცია არსებულ სისტემებთან", "ინტერფეისი, რომელსაც თქვენი გუნდი რეალურად გამოიყენებს"],
      },
      {
        slug: "business-automation",
        title: "ბიზნეს პროცესების ავტომატიზაცია",
        summary: "განმეორებადი ხელით შესრულებული სამუშაოს მოცილება საოპერაციო პროცესებიდან მიზნობრივი ავტომატიზაციით.",
        outcomes: ["ნაკლები განმეორებადი ხელით ეტაპი", "პროცესები, რომლებიც სტაბილურად მუშაობს", "დრო, გადამისამართებული უფრო ღირებულ სამუშაოზე"],
      },
      {
        slug: "website-development",
        title: "ვებგვერდის დიზაინი და განვითარება",
        summary: "ინდივიდუალურად კოდირებული, მაღალი წარმადობის ბიზნეს და SaaS ვებგვერდები, ორიენტირებული სანდოობასა და კონვერსიაზე.",
        outcomes: ["სწრაფი, პროფესიონალური, სანდო ვებგვერდი", "მრავალჯერადი გამოყენების დიზაინის სისტემა მომავალი გვერდებისთვის", "SEO-სთვის მზა სტრუქტურა პირველივე დღიდან"],
      },
      {
        slug: "consulting-support",
        title: "პროგრამული უზრუნველყოფის კონსულტაცია და ტექნიკური მხარდაჭერა",
        summary: "ტექნიკური კონსულტირება, არქიტექტურის მიმოხილვა და მუდმივი მხარდაჭერა არსებული პროგრამული უზრუნველყოფისთვის.",
        outcomes: ["ნათელი, პრაქტიკული ტექნიკური მიმართულება", "არქიტექტურა, შემოწმებული გამოცდილი პროდუქტის გუნდის მიერ", "მუდმივი მხარდაჭერა, რომელზეც შეგიძლიათ დაეყრდნოთ"],
      },
    ],
    approach: {
      eyebrow: "როგორ ვმუშაობთ",
      heading: "პროდუქტული აზროვნება — თქვენს პროექტში.",
      body: "ჩვენ ყოველ პროექტს ისე ვუდგებით, როგორც საკუთარ პროდუქტებს — შედეგიდან ვიწყებთ და არა ფუნქციების სიიდან.",
      steps: [
        { title: "გაგება", description: "ჩვენ ვიწყებთ ბიზნეს ამოცანის გააზრებით და არა მხოლოდ ტექნიკური დავალებით." },
        { title: "დაპროექტება და შექმნა", description: "ვაპროექტებთ და ვქმნით იმავე სტანდარტებით, რომლებითაც Tetri Copilot-სა და Tetri Engage-ს ვქმნით." },
        { title: "მხარდაჭერა", description: "გაშვების შემდეგაც ჩართული ვრჩებით, რომ პროგრამულმა უზრუნველყოფამ იმუშაოს თქვენი ბიზნესის ცვლილებებთან ერთად." },
      ],
    },
    proof: {
      heading: "შექმნილია Tetri Copilot-ისა და Tetri Engage-ის გუნდის მიერ",
      body: "ჩვენი სერვისების შესაძლებლობა პირდაპირ საკუთარი პროდუქტების შექმნისა და მართვის გამოცდილებიდან მომდინარეობს — იგივე საინჟინრო სტანდარტები, გამოყენებული თქვენს პროექტში.",
    },
    faq: {
      heading: "ხშირად დასმული კითხვები",
      items: [
        {
          question: "Tetri Copilot LLC ყველა პროექტს იღებს?",
          answer: "არა. ერთდროულად შერჩეულ რაოდენობის კლიენტთან ვმუშაობთ, რომ ყოველ პროექტს პროდუქტის გუნდის რეალური ყურადღება მიექცეს.",
        },
        {
          question: "ეს იმავე გუნდია, რომელიც Tetri Copilot-სა და Tetri Engage-ს ქმნის?",
          answer: "დიახ. სერვისებს ახორციელებს იგივე გუნდი და საკუთარ პროდუქტებში გამოყენებული იგივე საინჟინრო სტანდარტები.",
        },
        {
          question: "შესაძლებელია სერვისების Tetri Copilot-თან ან Tetri Engage-თან ინტეგრირება?",
          answer: "ხშირ შემთხვევაში — დიახ. დაგვიკავშირდით და განვიხილავთ, რა შეესაბამება თქვენს გარემოს.",
        },
      ],
    },
    cta: {
      heading: "გაქვთ პროექტის იდეა?",
      body: "გვიამბეთ მასზე და გეტყვით, შესაფერისია თუ არა ჩვენთვის.",
      ctaLabel: "პროექტის განხილვა",
    },
  },

  contact: {
    hero: {
      eyebrow: "კონტაქტი",
      heading: "განვიხილოთ, რა გჭირდებათ.",
      subheading: "პროდუქტთან დაკავშირებული კითხვები, პარტნიორობის იდეები ან პროექტი, რომლის განხილვაც გსურთ — გვსურს თქვენგან გაგება.",
    },
    reasons: [
      { title: "პროდუქტთან დაკავშირებული კითხვები", description: "კითხვები Tetri Copilot-ისა და Tetri Engage-ის შესახებ." },
      { title: "პარტნიორობა", description: "სარეფერალო, სარეალიზაციო ან ტექნოლოგიური პარტნიორობის შესაძლებლობები." },
      { title: "სერვისები", description: "პროგრამული უზრუნველყოფის, AI-ის ან ვებ განვითარების პროექტები." },
      { title: "სხვა ყველაფერი", description: "მედია, კომპანიასთან დაკავშირებული კითხვები ან ზემოთ ჩამოთვლილში არარსებული თემები." },
    ],
    info: {
      heading: "პირდაპირი კონტაქტი",
      emailLabel: "ელფოსტა",
      phoneLabel: "ტელეფონი",
      phones: ["+995 55 000 4769", "+995 511 415 313"],
      locationLabel: "მდებარეობა",
      locationValue: "საქართველო — ვმუშაობთ საქართველოში, არაბთა გაერთიანებულ საემიროებში, საუდის არაბეთში, აშშ-სა და მთელ მსოფლიოში",
    },
    form: {
      heading: "მოგვწერეთ შეტყობინება",
      nameLabel: "სახელი",
      namePlaceholder: "თქვენი სრული სახელი",
      emailLabel: "სამუშაო ელფოსტა",
      emailPlaceholder: "you@company.com",
      companyLabel: "კომპანია",
      companyPlaceholder: "თქვენი კომპანიის სახელი",
      inquiryTypeLabel: "მიმართვის ტიპი",
      inquiryTypePlaceholder: "აირჩიეთ მიმართვის ტიპი",
      inquiryTypes: [
        { value: "product", label: "პროდუქტთან დაკავშირებული კითხვა" },
        { value: "sales-demo", label: "გაყიდვები / დემონსტრაცია" },
        { value: "partnership", label: "პარტნიორობა" },
        { value: "software-development", label: "პროგრამული უზრუნველყოფის განვითარება" },
        { value: "ai-automation", label: "AI / ავტომატიზაცია" },
        { value: "website-development", label: "ვებგვერდის განვითარება" },
        { value: "media", label: "მედია / კომპანია" },
        { value: "other", label: "სხვა" },
      ],
      countryLabel: "ქვეყანა (არასავალდებულო)",
      countryPlaceholder: "თქვენი ქვეყანა",
      messageLabel: "შეტყობინება",
      messagePlaceholder: "მოგვიყევით მოკლედ, რა გჭირდებათ.",
      privacyNotice: "გაგზავნით თქვენ ეთანხმებით ჩვენს კონფიდენციალურობის პოლიტიკას. თქვენს მონაცემებს ვიყენებთ მხოლოდ თქვენს მიმართვაზე პასუხის გასაცემად.",
      submit: "შეტყობინების გაგზავნა",
      submitting: "იგზავნება…",
      successHeading: "შეტყობინება გაიგზავნა.",
      successBody: "გმადლობთ — მივიღეთ თქვენი შეტყობინება და მალე დაგიკავშირდებით.",
      errorHeading: "რაღაც შეცდომით წარიმართა.",
      errorBody: "შეტყობინება ვერ გაიგზავნა. სცადეთ ხელახლა, ან პირდაპირ მოგვწერეთ ელფოსტაზე.",
      retry: "ხელახლა ცდა",
      devModeHeading: "საკონტაქტო ფორმა ჯერ არ არის დაკავშირებული",
      devModeBody:
        "ამ გარემოში საკონტაქტო ფორმის მისამართი არ არის მითითებული, ამიტომ გაგზავნა შეუძლებელია. მიუთითეთ VITE_CONTACT_FORM_ENDPOINT (იხილეთ .env.example) მის ჩასართავად.",
      validation: {
        required: "ეს ველი სავალდებულოა.",
        invalidEmail: "მიუთითეთ სწორი ელფოსტის მისამართი.",
        tooShort: "გთხოვთ, დაამატოთ ცოტა მეტი დეტალი.",
      },
    },
  },

  legal: {
    privacy: {
      title: "კონფიდენციალურობის პოლიტიკა",
      updated: "ბოლო განახლება: 2026 წლის სექტემბერი",
      intro:
        "ეს პოლიტიკა განმარტავს, თუ რა ინფორმაციას აგროვებს Tetri Copilot LLC ამ ვებგვერდის მეშვეობით და როგორ გამოიყენება იგი. ის ეხება მხოლოდ tetricopilot.com-ის კორპორატიულ ვებგვერდს; Tetri Copilot-სა და Tetri Engage-ს შესაძლოა ჰქონდეთ საკუთარი კონფიდენციალურობის შეტყობინებები.",
      sections: [
        {
          title: "რა ინფორმაციას ვაგროვებთ",
          description: "საკონტაქტო ფორმის გაგზავნისას ვაგროვებთ თქვენ მიერ მოწოდებულ ინფორმაციას — სახელი, სამუშაო ელფოსტა, კომპანია და შეტყობინება. ვებგვერდის დათვალიერებისთვის ანგარიში საჭირო არ არის.",
        },
        {
          title: "როგორ ვიყენებთ ინფორმაციას",
          description: "საკონტაქტო ფორმის მონაცემებს ვიყენებთ მხოლოდ თქვენს მიმართვაზე პასუხის გასაცემად და საქმიანი კომუნიკაციის ჩანაწერის შესანარჩუნებლად. პერსონალურ მონაცემებს მესამე მხარეს არ ვყიდით.",
        },
        {
          title: "Cookie და ანალიტიკა",
          description: "ვებგვერდმა შესაძლოა გამოიყენოს აუცილებელი cookie-ები ძირითადი ფუნქციონირებისთვის და კონფიდენციალურობაზე ორიენტირებული ანალიტიკა ვებგვერდის საერთო გამოყენების გასაგებად. დეტალებისთვის იხილეთ Cookie-ების პოლიტიკა.",
        },
        {
          title: "მონაცემთა შენახვა",
          description: "საკონტაქტო მიმართვებს ვინახავთ იმდენ ხანს, რამდენადაც გონივრულად საჭიროა პასუხის გასაცემად და საქმიანი მიმართვების დოკუმენტირებისთვის.",
        },
        {
          title: "თქვენი უფლებები",
          description: "შეგიძლიათ მოითხოვოთ თქვენ მიერ მოწოდებული ინფორმაციის ნახვა, შესწორება ან წაშლა info@tetricopilot.com-ზე მიწერით.",
        },
        {
          title: "კონტაქტი",
          description: "ამ პოლიტიკასთან დაკავშირებული კითხვები გამოგზავნეთ info@tetricopilot.com-ზე.",
        },
      ],
    },
    terms: {
      title: "მომსახურების პირობები",
      updated: "ბოლო განახლება: 2026 წლის სექტემბერი",
      intro:
        "ეს პირობები არეგულირებს Tetri Copilot LLC-ის კორპორატიული ვებგვერდის გამოყენებას. ცალკეული Tetri პროდუქტების (Tetri Copilot, Tetri Engage) გამოყენება რეგულირდება მათი საკუთარი პირობებით, ხელმისაწვდომია შესაბამის ვებგვერდებზე.",
      sections: [
        {
          title: "ვებგვერდის გამოყენება",
          description: "ეს ვებგვერდი წარმოადგენს Tetri Copilot LLC-ს, Tetri-ის პროდუქტების ოჯახსა და ჩვენს სერვისებს. თქვენ ეთანხმებით მის გამოყენებას მხოლოდ კანონიერი მიზნებისთვის.",
        },
        {
          title: "ინტელექტუალური საკუთრება",
          description: "Tetri-ის სახელი, ლოგო და ვებგვერდის შინაარსი Tetri Copilot LLC-ის საკუთრებაა და მათი გამოყენება ნებართვის გარეშე დაუშვებელია.",
        },
        {
          title: "გარანტიის არარსებობა",
          description: "ეს ვებგვერდი და მისი შინაარსი მოწოდებულია „როგორც არის“ — ყოველგვარი გარანტიის გარეშე, კანონით დაშვებულ ფარგლებში.",
        },
        {
          title: "პასუხისმგებლობის შეზღუდვა",
          description: "Tetri Copilot LLC არ იღებს პასუხისმგებლობას ირიბ ან შედეგობრივ ზიანზე, რომელიც ვებგვერდის გამოყენებას უკავშირდება, კანონით დაშვებულ ფარგლებში.",
        },
        {
          title: "პირობების ცვლილება",
          description: "ჩვენ შეგვიძლია დროდადრო განვაახლოთ ეს პირობები. ვებგვერდის შემდგომი გამოყენება ნიშნავს მოქმედი პირობების მიღებას.",
        },
        {
          title: "კონტაქტი",
          description: "ამ პირობებთან დაკავშირებული კითხვები გამოგზავნეთ info@tetricopilot.com-ზე.",
        },
      ],
    },
    cookies: {
      title: "Cookie-ების პოლიტიკა",
      updated: "ბოლო განახლება: 2026 წლის სექტემბერი",
      intro: "ეს პოლიტიკა განმარტავს, თუ როგორ იყენებს Tetri Copilot LLC cookie-ებსა და მსგავს ტექნოლოგიებს ამ ვებგვერდზე.",
      sections: [
        {
          title: "რომელ cookie-ებს ვიყენებთ",
          description: "ვიყენებთ აუცილებელ cookie-ებს ვებგვერდის სწორად ფუნქციონირებისთვის და შესაძლოა გამოვიყენოთ კონფიდენციალურობაზე ორიენტირებული ანალიტიკური cookie-ები ვებგვერდის საერთო გამოყენების გასაგებად.",
        },
        {
          title: "Cookie-ების მართვა",
          description: "უმეტესი ბრაუზერი საშუალებას გაძლევთ მართოთ ან გამორთოთ cookie-ები პარამეტრებში. აუცილებელი cookie-ების გამორთვამ შესაძლოა გავლენა მოახდინოს ვებგვერდის ზოგიერთი ნაწილის მუშაობაზე.",
        },
        {
          title: "მესამე მხარის cookie-ები",
          description: "ამ ვებგვერდზე მესამე მხარის სარეკლამო cookie-ებს არ ვუშვებთ.",
        },
        {
          title: "კონტაქტი",
          description: "ამ პოლიტიკასთან დაკავშირებული კითხვები გამოგზავნეთ info@tetricopilot.com-ზე.",
        },
      ],
    },
  },

  notFound: {
    eyebrow: "404",
    heading: "ეს გვერდი არ არსებობს.",
    body: "გვერდი, რომელსაც ეძებთ, შესაძლოა გადატანილი იყოს ან საერთოდ არ არსებობდეს. აი, რამდენიმე გამოსადეგი მიმართულება.",
    ctaHome: "მთავარი",
    ctaProducts: "პროდუქტები",
    ctaContact: "კონტაქტი",
  },
};

export default ka;
